module.exports = __webpack_public_path__ + "media/assets/icons/chevron-left-52a96838cff92c1a33aebd0dc235546f.png";